<template>
  <div id="postwurfspezial-canvas" data-tap-disabled="true"></div>
</template>

<script>
import L, { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";
import { apiService } from "@/services/ApiService";

export default {
  name: "RegionsMap",
  props: {
    regions: Array,
  },
  data() {
    return {
      bounds: null,
      map: null,
      homeMarker: null,
      markersArr: [],
      layerGroupMarkers: null,
      layerGroupRegions: null,
      userLocLatlng: [51.163361, 10.447683],
    };
  },
  computed: {},
  created() {},
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.bounds = L.latLngBounds();
      this.layerGroupMarkers = new L.featureGroup();
      this.layerGroupRegions = new L.featureGroup();

      // this part resolve an issue where the markers would not appear
      delete Icon.Default.prototype._getIconUrl;
      Icon.Default.mergeOptions({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
      });

      // OpenStreetMap
      var mbAttr =
          'Kartendaten &copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> Mitwirkende',
        mbUrl = "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png";

      let grayscale = L.tileLayer(mbUrl, {
          id: "mapbox.light",
          attribution: mbAttr,
        }),
        streets = L.tileLayer(mbUrl, {
          id: "mapbox.streets",
          attribution: mbAttr,
        });

      this.map = L.map("postwurfspezial-canvas", {
        center: this.userLocLatlng,
        zoom: 6,
        layers: [grayscale, streets],
      });

      this.homeMarker = L.marker(this.userLocLatlng);

      // this.map.on("moveend", this.updateMapMarker);
      // this.updateMapMarker();
    },

    updateMapMarker() {
      apiService
        .marker(
          this.userLocLatlng[0],
          this.userLocLatlng[1],
          this.map.getBounds().toBBoxString()
        )
        .then((response) => {
          // console.log("marker response", response);
          for (let i = 0; i < response.markers.length; i++) {
            const lat = response.markers[i].position.lat;
            const lng = response.markers[i].position.lng;
            // Only add marker if not exists
            if (
              this.markersArr.filter(function (e) {
                return e === lat + "," + lng;
              }).length === 0
            ) {
              const layer = new L.marker([lat, lng], {
                zip: response.markers[i].zip,
                name: response.markers[i].name,
              }).addTo(this.map);
              layer.bindTooltip(response.markers[i].name);
              this.layerGroupMarkers.addLayer(layer);
              this.markersArr.push(lat + "," + lng);
            }
          }
        })
        .catch((error) => {
          console.error("Error", error);
          alert(
            "Aktuell kann diese Funktion leider nicht verwendet werden. Bitte versuchen Sie es später erneut."
          );
        });
    },

    addRegion(region) {
      // console.log("RegionsMap addRegion", region);
      Object.keys(region.shapes).forEach((key) => {
        let layer = L.geoJSON(region.shapes[key], {
          style: {
            fillColor: "#F4DB77",
            fillOpacity: 0.8,
            weight: 2,
            color: "#8B0000",
          },
        });
        layer.layerID = region.label;

        this.layerGroupRegions.addLayer(layer).addTo(this.map);
        // layer.bindTooltip(region.label);
        this.map.fitBounds(this.layerGroupRegions.getBounds());
      });
    },

    deleteRegion(region) {
      // console.log("RegionsMap deleteRegion", region);
      this.layerGroupRegions.eachLayer(function (layer) {
        if (layer.layerID === region.label) {
          this.layerGroupRegions.removeLayer(layer);
        }
      }, this);
    },
  },
};
</script>

<style lang="scss" scoped>
#postwurfspezial-canvas {
  width: 100%;
  height: 550px;
}
</style>
